import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { Button } from "Components";
import { isModuleSettingsValidationError, validateLMSModuleSettings } from "Pages/User/EditUser/tabs/ModuleSettings/ModuleSettings.helpers";
import { useIsModuleSettingDisabled } from "Pages/User/EditUser/tabs/ModuleSettings/ModuleSettingsContainer";
import { EditUserValues } from "Pages/User/User.types";

const SaveButton = ({ saveChanges } : { saveChanges: () => void }) => {
	const { t } = useTranslation();
	const { getIsLMSModuleSettingsDisabled } = useIsModuleSettingDisabled();
    const { isValid, dirty, isSubmitting, values, setErrors } = useFormikContext<EditUserValues>();
    const disabled = !(isValid && dirty);

    const handleSubmit = () => {
        try {
			const isModuleSettingsDisabled = getIsLMSModuleSettingsDisabled(values);
            if(!isModuleSettingsDisabled) validateLMSModuleSettings(isModuleSettingsDisabled, values);
            saveChanges();
        } catch (e) {
			const error = e as Error;
            if (isModuleSettingsValidationError(error)) {
				setErrors({ moduleSettings: error.message });
				return;
			}
        }
    }

    return <div className='btn-footer'>
        <Button shape="round" type="primary" disabled={disabled} loading={isSubmitting} onClick={handleSubmit} className={disabled ? 'cta-disabled' : ''}>{t(`saveChanges`)}</Button>
    </div>
}

export default SaveButton;